import styled from 'styled-components'

export const DataBreakdownTableWrapper = styled.div`
  width: 100%;
  padding-bottom: 31px;
  border-collapse: collapse;
`

export const DataBreakdownTableHeader = styled.div`
  // Themed Properties
  border-bottom: ${({ theme }) => `2px solid ${theme.colors.primary}`};

  // Conditional Properties
  ${({ withHeader }) => !withHeader && 'display: none;'}
`

export const DataBreakdownTableHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`

export const DataBreakdownTableHeaderRowMultiple = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;
`

export const DataBreakdownTableHeaderItem = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
  }

  // Themed Properties
  color: ${({ theme }) => theme.colors.primary};
`

export const DataBreakdownTableBody = styled.div`
  // Conditional Properties
  ${({ withData }) => !withData && 'display: none;'}
`

export const DataBreakdownTableRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
`

export const DataBreakdownTableRowMultiple = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
`

export const DataBreakdownTableRowData = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
    font-weight: 100;
  }

  // Themed Properties
  color: ${({ theme }) => theme.colors.primary};
`
